document.querySelectorAll('[data-menu-close]').forEach((button) => {
  button.addEventListener('click', () => {
    const menu = document.querySelector('[data-mobile-menu]');
    const toggle = document.querySelector('[data-menu-toggle]');
    if (!menu) return;
    menu.classList.remove('is-open');
    document.body.classList.remove('menu-open');
    toggle?.setAttribute('aria-expanded', 'false');
    window.setTimeout(() => { menu.hidden = true; }, 280);
  });
});

document.querySelectorAll('[data-service-explorer]').forEach((explorer) => {
  const cards = [...explorer.querySelectorAll('[data-service-card]')];
  const search = explorer.querySelector('[data-service-search]');
  const empty = explorer.querySelector('[data-service-empty]');

  const normalize = (value) => value
    .toLocaleLowerCase('nb-NO')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .trim();

  const sliders = [...explorer.querySelectorAll('[data-service-slider]')].map((slider) => {
    const track = slider.querySelector('[data-service-track]');
    const sliderCards = [...slider.querySelectorAll('[data-service-card]')];
    const dots = [...slider.querySelectorAll('[data-slider-dot]')];
    const current = slider.closest('[data-service-group]')?.querySelector('[data-current-slide]');
    const previous = slider.querySelector('[data-slider-prev]');
    const next = slider.querySelector('[data-slider-next]');
    let scrollFrame = null;

    const visibleCards = () => sliderCards.filter((card) => !card.hidden);
    const activeIndex = () => {
      const visible = visibleCards();
      if (!track || visible.length === 0) return 0;
      const trackLeft = track.getBoundingClientRect().left;
      return visible.reduce((best, card, index) => {
        const distance = Math.abs(card.getBoundingClientRect().left - trackLeft);
        return distance < best.distance ? { index, distance } : best;
      }, { index: 0, distance: Infinity }).index;
    };
    const update = () => {
      const visible = visibleCards();
      const index = activeIndex();
      if (current) current.textContent = visible.length ? index + 1 : 0;
      dots.forEach((dot, originalIndex) => {
        const card = sliderCards[originalIndex];
        dot.hidden = !card || card.hidden;
        dot.classList.toggle('is-active', Boolean(card && !card.hidden && card === visible[index]));
      });
      if (previous) previous.disabled = visible.length === 0 || index === 0;
      if (next) next.disabled = visible.length === 0 || index >= visible.length - 1;
    };
    const goTo = (card) => {
      if (!track || !card) return;
      const offset = card.getBoundingClientRect().left - track.getBoundingClientRect().left;
      track.scrollBy({ left: offset, behavior: 'smooth' });
    };
    const move = (direction) => {
      const visible = visibleCards();
      const target = Math.max(0, Math.min(visible.length - 1, activeIndex() + direction));
      goTo(visible[target]);
    };

    previous?.addEventListener('click', () => move(-1));
    next?.addEventListener('click', () => move(1));
    track?.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowRight') { event.preventDefault(); move(1); }
      if (event.key === 'ArrowLeft') { event.preventDefault(); move(-1); }
    });
    track?.addEventListener('scroll', () => {
      if (scrollFrame) window.cancelAnimationFrame(scrollFrame);
      scrollFrame = window.requestAnimationFrame(update);
    }, { passive: true });
    dots.forEach((dot, index) => dot.addEventListener('click', () => goTo(sliderCards[index])));
    window.addEventListener('resize', update, { passive: true });
    return { track, update };
  });

  const apply = () => {
    const term = normalize(search?.value || '');
    let visible = 0;
    cards.forEach((card) => {
      const searchMatch = !term || normalize(card.dataset.search || '').includes(term);
      card.hidden = !searchMatch;
      if (!card.hidden) visible += 1;
    });
    explorer.querySelectorAll('[data-service-group]').forEach((group) => {
      group.hidden = term !== '' && !group.querySelector('[data-service-card]:not([hidden])');
    });
    if (empty) empty.hidden = visible !== 0;
    sliders.forEach(({ track, update }) => {
      if (track) track.scrollLeft = 0;
      window.requestAnimationFrame(update);
    });
  };

  search?.addEventListener('input', apply);
  apply();
});

const initCarBooking = (scope = document) => {
  scope.querySelectorAll('[data-car-booking]').forEach((booking) => {
    if (booking.dataset.bookingInitialized === 'true') return;
    booking.dataset.bookingInitialized = 'true';

    const modes = [...booking.querySelectorAll('[data-booking-mode]')];
    const choices = [...booking.querySelectorAll('[data-booking-choice]')];
    const calendar = booking.querySelector('[data-booking-calendar]');
    const confirmation = booking.querySelector('[data-booking-confirmation]');
    const dateInput = booking.querySelector('[data-booking-date]');
    const timeInput = booking.querySelector('[data-booking-time]');
    const minimumDays = Math.max(0, Number.parseInt(booking.dataset.minDays || '0', 10) || 0);

    if (dateInput) {
      const minimumDate = new Date();
      minimumDate.setHours(12, 0, 0, 0);
      minimumDate.setDate(minimumDate.getDate() + minimumDays);
      const year = minimumDate.getFullYear();
      const month = String(minimumDate.getMonth() + 1).padStart(2, '0');
      const day = String(minimumDate.getDate()).padStart(2, '0');
      dateInput.min = `${year}-${month}-${day}`;
      if (dateInput.value && dateInput.value < dateInput.min) dateInput.value = '';
    }

    const updateBookingMode = () => {
      const selected = modes.find((mode) => mode.checked);
      const isScheduled = selected?.dataset.bookingMode !== 'flexible';
      calendar?.classList.toggle('is-disabled', !isScheduled);
      calendar?.setAttribute('aria-hidden', String(!isScheduled));
      if (confirmation) confirmation.hidden = !isScheduled;
      [dateInput, timeInput].forEach((field) => {
        if (!field) return;
        field.disabled = !isScheduled;
        field.required = isScheduled;
      });
      choices.forEach((choice) => {
        choice.classList.toggle('is-selected', choice.querySelector('input')?.checked === true);
      });
    };

    modes.forEach((mode) => mode.addEventListener('change', updateBookingMode));
    updateBookingMode();
  });
};

initCarBooking();
document.addEventListener('shopify:section:load', (event) => initCarBooking(event.target));

const catalogSearchCache = new Map();

const initCatalogSearch = (scope = document) => {
  scope.querySelectorAll('[data-catalog-search]').forEach((widget) => {
    if (widget.dataset.catalogSearchInitialized === 'true') return;
    widget.dataset.catalogSearchInitialized = 'true';

    const input = widget.querySelector('[data-catalog-search-input]');
    const results = widget.querySelector('[data-catalog-search-results]');
    const status = widget.querySelector('[data-catalog-search-status]');
    const clear = widget.querySelector('[data-catalog-search-clear]');
    if (!input || !results || !status) return;

    const rootUrlValue = window.Shopify?.routes?.root || widget.dataset.rootUrl || '/';
    const rootUrl = rootUrlValue.endsWith('/') ? rootUrlValue : `${rootUrlValue}/`;
    const labels = {
      searching: widget.dataset.searchingLabel || 'Søker …',
      empty: widget.dataset.emptyLabel || 'Ingen treff.',
      results: widget.dataset.resultsLabel || 'forslag funnet',
      all: widget.dataset.allResultsLabel || 'Vis alle resultater'
    };
    const normalize = (value) => value
      .toLocaleLowerCase('nb-NO')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9æøå\s-]/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
    const synonymGroups = [
      { aliases: ['bukse', 'bukser', 'bukseben', 'opplegg', 'legge opp', 'forkorte', 'jeans'], query: 'bukse' },
      { aliases: ['jakke', 'kape', 'kåpe', 'frakk', 'yttertoy', 'yttertøy'], query: 'jakke' },
      { aliases: ['kjole', 'brudekjole', 'brude', 'bunad', 'festplagg'], query: 'kjole bunad' },
      { aliases: ['skjorte', 'genser', 'bluse', 'erm', 'ermer'], query: 'skjorte genser' },
      { aliases: ['glidelas', 'glidelås', 'glidelaas', 'zip', 'zipper', 'las'], query: 'glidelås' },
      { aliases: ['rens', 'rense', 'renseri', 'vask', 'vaske', 'vasking', 'dryclean'], query: 'rens vask' },
      { aliases: ['dress', 'smoking', 'herredress'], query: 'dress rens' },
      { aliases: ['sko', 'skorens', 'sneaker', 'sneakers', 'stovler', 'støvler'], query: 'sko rens' },
      { aliases: ['dyne', 'dyner', 'pute', 'puter', 'sengeteppe', 'soverom'], query: 'dyne pute' },
      { aliases: ['gardin', 'gardiner', 'duk', 'duker', 'hjemmetekstil', 'boligtekstil'], query: 'gardin duk' },
      { aliases: ['skinn', 'laer', 'lær', 'pels', 'semsket'], query: 'skinn rens' },
      { aliases: ['bil', 'bilvask', 'bilpleie', 'bilrengjoring', 'bilrengjøring', 'sedan', 'suv', 'kupe', 'kupé'], query: 'bilrengjøring' },
      { aliases: ['reparasjon', 'reparere', 'lappe', 'lapp', 'som', 'søm', 'sy'], query: 'reparasjon systue' }
    ];

    let debounceTimer;
    let controller;
    let activeIndex = -1;
    let options = [];

    const setOpen = (open) => {
      results.hidden = !open;
      input.setAttribute('aria-expanded', String(open));
      if (!open) {
        activeIndex = -1;
        input.removeAttribute('aria-activedescendant');
      }
    };

    const editDistance = (first, second) => {
      const row = Array.from({ length: second.length + 1 }, (_, index) => index);
      for (let firstIndex = 1; firstIndex <= first.length; firstIndex += 1) {
        let previous = row[0];
        row[0] = firstIndex;
        for (let secondIndex = 1; secondIndex <= second.length; secondIndex += 1) {
          const current = row[secondIndex];
          row[secondIndex] = Math.min(
            row[secondIndex] + 1,
            row[secondIndex - 1] + 1,
            previous + (first[firstIndex - 1] === second[secondIndex - 1] ? 0 : 1)
          );
          previous = current;
        }
      }
      return row[second.length];
    };

    const isRelated = (term, alias) => {
      const normalizedAlias = normalize(alias);
      if (term.includes(normalizedAlias) || normalizedAlias.startsWith(term)) return true;
      return term.split(' ').some((word) => {
        if (word.length < 4 || normalizedAlias.includes(' ')) return false;
        const allowedDistance = word.length >= 8 ? 2 : 1;
        return Math.abs(word.length - normalizedAlias.length) <= allowedDistance
          && editDistance(word, normalizedAlias) <= allowedDistance;
      });
    };

    const canonicalQuery = (term) => {
      const normalizedTerm = normalize(term);
      const match = synonymGroups.find((group) => group.aliases.some((alias) => isRelated(normalizedTerm, alias)));
      return match?.query || '';
    };

    const searchEndpoint = (query) => {
      const params = new URLSearchParams();
      params.set('q', query);
      params.set('resources[type]', 'product,collection,page,article');
      params.set('resources[limit]', '10');
      params.set('resources[limit_scope]', 'each');
      params.set('resources[options][unavailable_products]', 'last');
      params.set('resources[options][fields]', 'title,product_type,variants.title,tag,body');
      return `${rootUrl}search/suggest.json?${params.toString()}`;
    };

    const fetchQuery = async (query, signal) => {
      if (catalogSearchCache.has(query)) return catalogSearchCache.get(query);
      const response = await fetch(searchEndpoint(query), { headers: { Accept: 'application/json' }, signal });
      if (!response.ok) throw new Error(`Search failed: ${response.status}`);
      const payload = await response.json();
      const resources = payload?.resources?.results || {};
      const items = [
        ...(resources.products || []).map((item) => ({ ...item, _resultType: 'product' })),
        ...(resources.collections || []).map((item) => ({ ...item, _resultType: 'collection' })),
        ...(resources.pages || []).map((item) => ({ ...item, _resultType: 'page' })),
        ...(resources.articles || []).map((item) => ({ ...item, _resultType: 'article' }))
      ];
      catalogSearchCache.set(query, items);
      return items;
    };

    const formatPrice = (product) => {
      const value = product.price_min ?? product.price;
      if (value === undefined || value === null || value === '') return '';
      const number = Number(value);
      if (!Number.isFinite(number)) return String(value);
      const currency = window.Shopify?.currency?.active || 'NOK';
      return new Intl.NumberFormat('nb-NO', { style: 'currency', currency, maximumFractionDigits: 0 }).format(number);
    };

    const makeResult = (product, index) => {
      const link = document.createElement('a');
      link.className = 'catalog-search__result';
      link.href = product.url;
      link.id = `CatalogSearchOption-${widget.id || 'collection'}-${index}`;
      link.setAttribute('role', 'option');
      link.setAttribute('aria-selected', 'false');

      const imageUrl = product.featured_image?.url || (typeof product.image === 'string' ? product.image : product.image?.url);
      if (imageUrl) {
        const image = document.createElement('img');
        image.src = imageUrl;
        image.alt = '';
        image.width = 116;
        image.height = 116;
        image.loading = 'lazy';
        link.append(image);
      } else {
        const placeholder = document.createElement('span');
        placeholder.className = 'catalog-search__result-image';
        placeholder.setAttribute('aria-hidden', 'true');
        link.append(placeholder);
      }

      const copy = document.createElement('span');
      copy.className = 'catalog-search__result-copy';
      const title = document.createElement('strong');
      title.textContent = product.title;
      const type = document.createElement('small');
      const typeLabels = { product: 'Produkt eller tjeneste', collection: 'Kategori', page: 'Informasjonsside', article: 'Artikkel' };
      type.textContent = product._resultType === 'product'
        ? (product.type || product.product_type || typeLabels.product)
        : (typeLabels[product._resultType] || 'ASTAMR');
      copy.append(title, type);
      link.append(copy);

      const priceText = product._resultType === 'product' ? formatPrice(product) : '';
      if (priceText) {
        const price = document.createElement('span');
        price.className = 'catalog-search__result-price';
        price.textContent = priceText;
        link.append(price);
      }

      link.addEventListener('mouseenter', () => setActive(index));
      return link;
    };

    const setActive = (index) => {
      options.forEach((option, optionIndex) => {
        const active = optionIndex === index;
        option.classList.toggle('is-active', active);
        option.setAttribute('aria-selected', String(active));
      });
      activeIndex = index;
      if (options[index]) {
        input.setAttribute('aria-activedescendant', options[index].id);
        options[index].scrollIntoView({ block: 'nearest' });
      } else {
        input.removeAttribute('aria-activedescendant');
      }
    };

    const render = (products, term) => {
      results.replaceChildren();
      options = [];
      activeIndex = -1;

      if (!products.length) {
        const empty = document.createElement('p');
        empty.className = 'catalog-search__empty';
        empty.textContent = labels.empty;
        results.append(empty);
        status.textContent = labels.empty;
        setOpen(true);
        return;
      }

      const fragment = document.createDocumentFragment();
      products.forEach((product, index) => fragment.append(makeResult(product, index)));
      const all = document.createElement('a');
      all.className = 'catalog-search__all';
      all.href = `${rootUrl}search?q=${encodeURIComponent(term)}`;
      const allText = document.createElement('span');
      allText.textContent = labels.all;
      const arrow = document.createElement('span');
      arrow.textContent = '→';
      all.append(allText, arrow);
      fragment.append(all);
      results.append(fragment);
      options = [...results.querySelectorAll('[role="option"]')];
      status.textContent = `${products.length} ${labels.results}`;
      setOpen(true);
    };

    const runSearch = async () => {
      const term = input.value.trim();
      clear.hidden = term.length === 0;
      if (term.length < 2) {
        controller?.abort();
        status.textContent = '';
        results.replaceChildren();
        setOpen(false);
        return;
      }

      controller?.abort();
      controller = new AbortController();
      status.textContent = labels.searching;
      const canonical = canonicalQuery(term);
      const queries = [...new Set([term, canonical].filter(Boolean))];

      try {
        const batches = await Promise.all(queries.map((query) => fetchQuery(query, controller.signal)));
        const seen = new Set();
        const products = batches.flat().filter((product) => {
          const key = `${product._resultType || 'product'}-${product.id || product.url}`;
          if (seen.has(key)) return false;
          seen.add(key);
          return true;
        }).slice(0, 12);
        render(products, term);
      } catch (error) {
        if (error.name === 'AbortError') return;
        render([], term);
      }
    };

    input.addEventListener('input', () => {
      window.clearTimeout(debounceTimer);
      debounceTimer = window.setTimeout(runSearch, 120);
    });
    input.addEventListener('focus', () => {
      if (results.childElementCount) setOpen(true);
    });
    input.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowDown' && options.length) {
        event.preventDefault();
        setOpen((activeIndex + 1) % options.length);
      } else if (event.key === 'ArrowUp' && options.length) {
        event.preventDefault();
        setOpen(activeIndex <= 0 ? options.length - 1 : activeIndex - 1);
      } else if (event.key === 'Enter' && activeIndex >= 0 && options[activeIndex]) {
        event.preventDefault();
        options[activeIndex].click();
      } else if (event.key === 'Escape') {
        setOpen(false);
      }
    });
    clear?.addEventListener('click', () => {
      input.value = '';
      clear.hidden = true;
      status.textContent = '';
      results.replaceChildren();
      setOpen(false);
      input.focus();
    });
    document.addEventListener('click', (event) => {
      if (!widget.contains(event.target)) setOpen(false);
    });

    if (input.value.trim().length >= 2) runSearch();
  });
};

initCatalogSearch();
document.addEventListener('shopify:section:load', (event) => initCatalogSearch(event.target));

const initGlobalSearchPanel = (scope = document) => {
  scope.querySelectorAll('[data-global-search-panel]').forEach((panel) => {
    if (panel.dataset.globalSearchInitialized === 'true') return;
    panel.dataset.globalSearchInitialized = 'true';
    const panelId = panel.id;
    const toggle = document.querySelector(`[data-global-search-toggle][aria-controls="${panelId}"]`);
    const input = panel.querySelector('[data-catalog-search-input]');
    const closeButtons = [...panel.querySelectorAll('[data-global-search-close]')];
    let lastFocused;

    const open = () => {
      lastFocused = document.activeElement;
      panel.hidden = false;
      document.body.classList.add('global-search-open');
      toggle?.setAttribute('aria-expanded', 'true');
      window.requestAnimationFrame(() => input?.focus());
    };
    const close = () => {
      panel.hidden = true;
      document.body.classList.remove('global-search-open');
      toggle?.setAttribute('aria-expanded', 'false');
      if (lastFocused instanceof HTMLElement) lastFocused.focus();
    };

    toggle?.addEventListener('click', open);
    closeButtons.forEach((button) => button.addEventListener('click', close));
    panel.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        event.preventDefault();
        close();
      }
    });
  });
};

initGlobalSearchPanel();
document.addEventListener('shopify:section:load', (event) => initGlobalSearchPanel(event.target));
